<template>
  <section class="hero is-fullheight">

    <div class="hero-head">
      <b-navbar :mobile-burger="false">
        <template #brand>
          <b-navbar-item tag="a" href="/">
            <img src="/icon.png" alt="Kiosk">
          </b-navbar-item>
        </template>
      </b-navbar>
    </div>

    <div class="hero-body">
      <router-view @updateCie="onCieCodeChange"></router-view>
    </div>

    <div class="hero-foot">
      <nav v-if="showCog" class="tabs is-boxed is-right">
        <div class="container">
          <ul>
            <li class="is-active">
              <a href="/ui/opt">
                <i class="fas fa-cog"></i>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>

  </section>
</template>

<script>
export default {
  name: 'App',
  data(){
    return  {
      showCog: localStorage.getItem('cie_code')
    }
  },
  methods: {
    onCieCodeChange(){
      this.showCog = localStorage.getItem('cie_code')
    }
  }
}
</script>
